import { FlagType } from '~/flags/flags';
import { useFlag } from '~/flags/useFlag';

import DocumentOverviewPanelNew from './DocumentOverviewPanel/DocumentOverviewPanel';
import DocumentOverviewPanelDeprecated from './DocumentOverviewPanelDeprecated/DocumentOverviewPanel';

export function DocumentOverviewPanelConditional(props: any) {
  const useNewPanel = useFlag(FlagType.DocumentOverviewEditFormEDSComponents);

  return useNewPanel ? (
    <DocumentOverviewPanelNew {...props} />
  ) : (
    <DocumentOverviewPanelDeprecated {...props} />
  );
}
